import {Button, ConfigProvider, notification, Row, Space} from 'antd';
import React, {Component} from 'react';
import './index.css';
import enUSIntl from "antd/lib/locale/en_US";
import ProTable, {ActionType, ProColumns} from "@ant-design/pro-table";
import {postRequest} from "../../../api/postRequest";
import {ClearOutlined, DownloadOutlined, FileTextOutlined, UploadOutlined} from "@ant-design/icons";
import CSVReader from "react-csv-reader";
import {auth} from "../../../config/firebase";
import axios from "axios";
import {API} from "../../../common/constants";
import withRouter from "../../../components/withRouter";


export interface IPaymentCycleAssetsProps {
    //Here we pass the Props Interface
    params: any
    pageSize?: number
    polling?: false | number
}

export interface IPaymentCycleAssetsState {
    importedData?: PaymentCycleAsset[]
    actionRef: React.RefObject<ActionType>
    data?: PaymentCycleAsset[]
    loading: boolean
    filteredData?: PaymentCycleAsset[]
}


type PaymentCycleAsset = {
    cycle_id: string
    asset_key: string
    asset_domain_id: number
    asset_domain: string
    customer_id: number
    commission: number
    affiliate_customer_id: number
    affiliate_commission: number
};


//class ComponentName Component<PropsInterface, StateInterface>
class PaymentCycleAssets extends Component<IPaymentCycleAssetsProps, IPaymentCycleAssetsState> {

    constructor(props: IPaymentCycleAssetsProps) {
        super(props);

        this.state = {
            loading: false,
            actionRef: React.createRef<ActionType>()
        }

    }

    //Add style here
    style = {};


    // Before the component mounts, we initialise our state
    componentWillMount() {

    }

    // After the component did mount, we set the state.
    componentDidMount() {
        this.getData()
    }

    getData = async () => {
        this.setState({loading: true})
        try {
            const res = await postRequest('/api/paymentCycles/getAssetsInfo/' + this.props.params.id)
            // console.log(res.data)
            this.setState({data: res.data, loading: false})
        } catch (e) {
            // return
            this.setState({loading: false})
        }
    }
    columns: ProColumns<PaymentCycleAsset>[] = [
        {title: 'Asset key', dataIndex: 'asset_key', valueType: 'text',},
        {
            title: 'Asset domain',
            dataIndex: 'asset_domain',
            valueType: 'select',
            valueEnum: {
                'Youtube Channels': {text: 'Youtube Channels'},
                'Youtube Asset Labels': {text: 'Youtube Asset Labels'},
                'Spotify Labels': {text: 'Spotify Labels'},
                'Music Distribution Labels DM': {text: 'Music Distribution Labels DM'},
                'Music Distribution Labels Panik': {text: 'Music Distribution Labels Panik'},
                'Music Distribution Labels Spicy': {text: 'Music Distribution Labels Spicy'},
            }
        },
        {title: 'Customer Id', dataIndex: 'customer_id', valueType: 'text',},
        {title: 'Commission', dataIndex: 'commission', valueType: 'digit', hideInSearch: true,},
        {title: 'Affiliate customer id', dataIndex: 'affiliate_customer_id', valueType: 'digit', hideInSearch: true,},
        {title: 'Affiliate commission', dataIndex: 'affiliate_commission', valueType: 'digit', hideInSearch: true,},
    ];

    onSubmit = async () => {
        if (!this.state.importedData) {
            notification.warning({message: 'No data loaded'})
            return
        }
        // return
        try {
            const res = await postRequest('/api/paymentCycles/uploadAssetsInfo/' + this.props.params.id, this.state.importedData, false)
            console.log(res)
            notification.success({message: 'OK'})
            this.state.actionRef.current?.reload()

            this.onClear()
        } catch (e) {
            notification.error({message: 'Something went wrong'})
        }
    }

    onClear = () => {
        // @ts-ignore
        document.querySelector('.csv-input').value = ''
        this.setState({importedData: undefined})
    }

    downloadSample = async () => {
        const token = await auth.currentUser?.getIdToken()
        axios
            .post(API + '/api/paymentCycles/sampleFiles/assets', null,
                {
                    headers: {
                        "Accept": "*/*",
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                        Authorization: `Bearer ${token}`
                    },
                    responseType: 'blob'
                })
            .then(res => {
                console.log(res)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'sample_assets.csv');
                document.body.appendChild(link);
                link.click();

                notification.success({message: 'Success'})
            }).catch(reason => {
            console.log(reason)
            notification.error({message: 'Error'})
        })
    }

    onSearch = (params: PaymentCycleAsset) => {
        let filteredData: PaymentCycleAsset[] = JSON.parse(JSON.stringify(this.state.data))
        Object.keys(params).map((key) => {
            if (params[key] == '') return true
            filteredData = filteredData.filter((datum) => {
                // console.log(key, params[key], datum[key].toString().toLowerCase().includes(params[key].toLowerCase()))
                // return datum[key] == params[key] // strict comparison
                return datum[key].toString().toLowerCase().includes(params[key].toLowerCase()) // loose comparison
            })
        })
        this.setState({filteredData})
    }
    onReset = () => {
        this.onSearch({} as any)
    }

    render() {


        return (
            <>

                {/*<Typography.Title level={4}>Payment Cycle {this.props.cycle_id} Logs</Typography.Title>*/}
                <Row justify={"space-between"}>
                    <Space>
                        <CSVReader
                            parserOptions={{
                                header: true,
                                dynamicTyping: true,
                                transform(value: string, field: string | number): any {
                                    if (field == 'commission' || field == 'affiliate_commission') {
                                        // replace comma with dot
                                        return value.replace(',', '.')
                                    }
                                    return value
                                }
                            }}
                            // inputRef={instance => {
                            //     console.log(instance)
                            // }}
                            // cssInputClass={"ant-btn ant-btn-default"}
                            label={'Upload / Replace Assets Data: '}
                            onFileLoaded={(data, fileInfo, originalFile) => {
                                console.log(data, fileInfo, originalFile)
                                this.setState({importedData: data})
                            }}
                            onError={error => {
                                notification.error({message: error.message})
                            }}
                        />

                        {this.state.importedData &&
                        <>
                            <Button type={"default"} onClick={this.onSubmit}
                                    size={"middle"}>Load<UploadOutlined/></Button>
                            <Button type={"default"} danger onClick={this.onClear}
                                    size={"middle"}>Clear<ClearOutlined/></Button>
                        </>
                        }
                    </Space>
                    <Button icon={<DownloadOutlined/>} onClick={this.downloadSample}>Download Sample</Button>
                </Row>
                <br/>


                <ConfigProvider locale={enUSIntl}>

                    {/*<Card bodyStyle={{padding: 0}}>*/}

                    <ProTable<PaymentCycleAsset>
                        columns={this.columns}
                        actionRef={this.state.actionRef as any}
                        // cardBordered
                        bordered
                        // size={"small"}
                        // style={{fontSize:6}}
                        // showHeader={false}
                        // headerTitle={"Logs"}
                        // polling={this.props.polling || 0}
                        // request={async (params = {}, sort, filter) => {
                        //     try {
                        //         const res = await postRequest('/api/paymentCycles/getAssetsInfo/' + this.props.cycle_id)
                        //         const data = res.data || []
                        //         console.log(res.data)
                        //         return {data, success: true, total: data.length}
                        //     } catch (e) {
                        //         return {data: [], success: false, total: 0}
                        //     }
                        // }}
                        rowKey={record => record.asset_key + record.asset_domain_id}
                        // search={false}
                        locale={{
                            emptyText: <Space direction={'vertical'}> <FileTextOutlined/>No exported unmatched
                                files</Space>
                        }}
                        pagination={{pageSize: this.props.pageSize || 10, hideOnSinglePage: true}}
                        dateFormatter="string"
                        // toolbar={{style: {marginBottom: 20, textAlign: "end"}}}
                        // toolBarRender={() => []}
                        loading={this.state.loading}
                        onSubmit={this.onSearch}
                        onReset={this.onReset}
                        search={{layout: "vertical"}}
                        dataSource={this.state.filteredData ? this.state.filteredData : this.state.data}
                        toolBarRender={false}
                    />
                    {/*</Card>*/}


                </ConfigProvider>

            </>
        );
    }
}

export default withRouter(PaymentCycleAssets);